import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";


export default class Confetti extends PIXI.Sprite
{
    private _speed: PIXI.Point = null;
    private _angularSpeed: number = null;


    public constructor( spriteId: string, speed: PIXI.Point, angularSpeed: number )
    {
        //super( ServiceLocator.resources[ "confetti_" + ( Math.floor( Math.random() * 9 ) ) ].texture );
        super( ServiceLocator.resources[ spriteId ].texture );

        this.anchor.set( 0.5 );
        this.scale.set( Math.random() * 0.25 + 0.25 );

        this._speed = speed;
        this._angularSpeed = angularSpeed;
    }

    public update( dt: number ): void
    {
        this.angle += this._angularSpeed * dt;
        this.x += this._speed.x * dt;
        this.y += this._speed.y * dt;
    }
}